import React from "react";
import { GlModal } from "@adl/component-modal";
import styles from "../consents.module.scss.js";
const ExplicitConsentModal = ({ showDetails, details, children, onClick }) => /* @__PURE__ */ React.createElement(
  GlModal,
  {
    id: "mf-consents",
    title: "Explicit Consents Modal",
    showTitle: false,
    closeButtonLabel: "",
    disablePortal: true,
    open: showDetails,
    onClose: onClick,
    size: "full-mobile",
    className: "read-more-modal"
  },
  /* @__PURE__ */ React.createElement("div", { dangerouslySetInnerHTML: { __html: details }, className: styles.legalText }),
  children
);
export {
  ExplicitConsentModal,
  ExplicitConsentModal as default
};
//# sourceMappingURL=explicit-consent-modal.js.map
